import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { backofficeUrlBase } from '@/config/envConfig';
let DataProtectionApi = class DataProtectionApi {
    constructor(http, coreBaseHttp) {
        this.http = http;
        this.coreBaseHttp = coreBaseHttp;
        this.baseUrl = backofficeUrlBase + '/backoffice/proxy';
    }
    // #region Export Management
    getRuleConfigList() {
        const url = `${this.baseUrl}/behavior/export/black/query/int`;
        return this.http.get({
            url,
        });
    }
    getConfigList(params) {
        const url = `${this.baseUrl}/behavior/export/black/query/config`;
        return this.http.get({
            url,
            params,
        });
    }
    saveToConfigure(data) {
        const url = `${this.baseUrl}/behavior/export/black/query/config/save`;
        return this.http.post({
            url,
            data,
        });
    }
    editToConfigure(id) {
        const url = `${this.baseUrl}/behavior/export/black/query/config/detail`;
        return this.http.get({
            url,
            params: { id },
        });
    }
    useDetail(configId) {
        const url = `${this.baseUrl}/behavior/alert/config/summary`;
        return this.http.get({
            url,
            params: { configId },
        });
    }
    deleteToConfigure(config_id) {
        const url = `${this.baseUrl}/behavior/export/black/query/config/delete`;
        return this.http.delete({
            url,
            params: { config_id },
        });
    }
    // #endregion
    // #region Restriction List
    getRestrictionList(params) {
        const url = `${this.baseUrl}/behavior/alert`;
        return this.http.get({
            url,
            params,
        });
    }
    relieveRestriction(data) {
        const url = `${this.baseUrl}/behavior/alert/relieve`;
        return this.http.post({
            url,
            data,
        });
    }
    disbaleRestriction(data) {
        const url = `${this.baseUrl}/behavior/alert/disable`;
        return this.http.post({
            url,
            data,
        });
    }
    getRestrictionDetails(params) {
        const url = `${this.baseUrl}/behavior/alert/details`;
        return this.http.get({
            url,
            params,
        });
    }
    // #endregion
    // #region Company Tree
    queryCompanyInfo(params) {
        const url = this.baseUrl + '/search/corporate-tree/records/fetch';
        return this.coreBaseHttp.post({
            url,
            data: params,
        });
    }
    queryKeyWord(params) {
        const url = this.baseUrl + '/search/corporate-tree/records/fetch/detail';
        return this.coreBaseHttp.post({
            url,
            data: params,
        });
    }
};
DataProtectionApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CoreBasicHttp)),
    __metadata("design:paramtypes", [Object, Object])
], DataProtectionApi);
export { DataProtectionApi };
